import React from "react";
import { Activity, Brain, Clock, FileCheck, HeartHandshake, House, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Co-Management & Band Advisory",
  description: "Professional guidance for First Nations to support transparent governance, effective oversight, long-term financial stability, and building internal capacity.",
  icon: Users
}, {
  title: "Loan Management & Administration",
  description: "Support for the administration of large loan arrangements, including blocked accounts, covenant reporting, clear reporting over borrowing obligations, and building trust through transparent reporting.",
  icon: Activity
}, {
  title: "Audit Catch-Up",
  description: "Specialized support to clear backlogs, reconcile complex accounts, and bring financial statements current for upcoming financial audits while supporting compliance requirements.",
  icon: Clock
}, {
  title: "Financial Management",
  description: "Comprehensive controllership services providing oversight, budgeting, and accurate financial reporting so leadership has the clarity needed for operations and growth.",
  icon: House
}, {
  title: "Project Planning & Delivery",
  description: "Development and management of complex projects, with a focus on advocating for community needs, supporting meaningful participation, and keeping timelines, budgets, objectives, and reporting requirements organized and on track.",
  icon: Brain
}, {
  title: "Reporting & Automation",
  description: "Implementation of modern systems to streamline data flow, improve accuracy, support follow-through and task tracking, and provide clearer financial and operational information for better decision-making.",
  icon: FileCheck
}];
export default function OurSpecializedCareServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="48854" id="practical-support-across-key-areas" ref={ref} className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className={cn("text-center max-w-3xl mx-auto mb-14 transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <span className="inline-block text-secondary font-default font-bold tracking-widest uppercase text-sm mb-4">
            What We Do
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary-500 mb-6 leading-tight">
            Practical support across key areas
          </h2>

          <p className="text-lg text-muted-foreground font-default leading-relaxed">
            RiverBend provides hands-on support across governance, financial
            management, audit readiness, project work, reporting systems, and
            specialized administrative functions that help organizations build
            clarity, stability, and capacity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-8">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={service.title} data-index={index} className={cn("h-full transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")} style={{
            transitionDelay: `${index * 100}ms`
          }}>
                <Card className="h-full bg-card border border-border shadow-sm hover:shadow-md hover:border-secondary/40 transition-all duration-300 rounded-lg overflow-hidden">
                  <CardContent className="p-7 md:p-8 flex flex-col h-full">
                    <div className="mb-6 size-14 rounded-full bg-secondary/10 flex items-center justify-center">
                      <Icon className="size-7 text-secondary" strokeWidth={1.7} />
                    </div>

                    <h3 className="text-xl md:text-2xl font-default font-bold text-primary-500 mb-4 leading-snug">
                      {service.title}
                    </h3>

                    <p className="text-muted-foreground leading-relaxed font-default">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}